import React from 'react';
import { FormGroup } from 'components/common/Forms';
import { withResolver } from 'components/common';
import { compose, withState, withPropsOnChange } from 'recompose';
import { Control, actions } from 'react-redux-form';
import { ApiClient } from 'services';
import Select from 'react-select';
import { flatten } from 'lodash';

export const CountriesAndRegions = ({
  countries,
  regions,
  postcodes,
  setRegions,
  item,
  dispatch,
  readOnly,
}) => (
  <div>
    <FormGroup label="Countries" addControlClass={false}>
      <Control.select
        component={Select}
        placeholder="Select a Country..."
        changeAction={(model, value) => {
          dispatch(actions.change(model, value.map(el => el.id)));
        }}
        model=".countries"
        multi
        disabled={readOnly}
        options={countries}
        labelKey="name"
        valueKey="id"
        isLoading={!countries}
      />
    </FormGroup>
    {regions &&
      regions.length > 0 && (
        <FormGroup label="Regions" model=".regions">
          <Control.select
            component={Select}
            placeholder={
              item.country ? 'Select a Region...' : 'Select a Country first...'
            }
            changeAction={(model, value) => {
              dispatch(actions.change(model, value.map(i => i.id)));
            }}
            disabled={readOnly || !regions}
            model=".regions"
            options={regions}
            labelKey="name"
            valueKey="id"
            multi
            isLoading={!regions && item.country}
          />
        </FormGroup>
      )}
    {regions && regions.length === 0 && <p>This Country has no Regions</p>}
    {postcodes &&
      postcodes.length > 0 && (
        <FormGroup label="Postcodes" model=".postcodes">
          <Control.select
            component={Select}
            placeholder={
              item.country ? 'Select a Postcode...' : 'Select a Country first...'
            }
            changeAction={(model, value) => {
              dispatch(actions.change(model, value.map(i => i.id)));
            }}
            disabled={readOnly || !postcodes || item.is_all_postcodes}
            model=".postcodes"
            options={postcodes}
            labelKey="postcode"
            valueKey="id"
            multi
            isLoading={!postcodes && item.country}
          />
        </FormGroup>
      )}
    {postcodes &&
      postcodes.length > 0 &&(
      <FormGroup label="All Postcodes" check disabled={readOnly}>
          <Control.checkbox 
            model=".is_all_postcodes"
          />
        </FormGroup>
      )}
    {postcodes && postcodes.length === 0 && <p>This Country has no Postcodes</p>}
  </div>
);

const enhance = compose(
  withState('countries', 'setCountries', []),
  withState('regions', 'setRegions', null),
  withState('postcodes', 'setPostcodes', null),
  withResolver(
    {
      countries: () => client => client.get('countries'),
    },
    {
      onResolved: ({ setCountries }) => ({ countries }) => {
        setCountries(countries);
      },
    }
  ),
  withPropsOnChange(['item'], ({ setRegions, item: { countries } }) => {
    if (!countries) {
      setRegions(null);
      return;
    }
    Promise.mapSeries(countries, country => ApiClient()
      .get(`countries/${country}/regions`)
      .then(result => {
        return result.data;
      })
      .catch(err => {
        throw err;
      })
    ).then(regions => {
      setRegions(flatten(regions))
    });
  }),
  withPropsOnChange(['item'], ({ setPostcodes, item: { countries } }) => {
    if (!countries) {
      setPostcodes(null);
      return;
    }
    Promise.mapSeries(countries, country => ApiClient()
      .get(`countries/${country}/postcodes`)
      .then(result => {
        return result.data;
      })
      .catch(err => {
        throw err;
      })
    ).then(postcodes => {
      setPostcodes(flatten(postcodes))
    });
  })
);

export default enhance(CountriesAndRegions);



// WEBPACK FOOTER //
// ./src/pages/Installers/CountriesAndRegions.jsx